import { render, staticRenderFns } from "./paiqi.vue?vue&type=template&id=cc002f9c&scoped=true&"
import script from "./paiqi.vue?vue&type=script&lang=js&"
export * from "./paiqi.vue?vue&type=script&lang=js&"
import style0 from "./paiqi.vue?vue&type=style&index=0&id=cc002f9c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc002f9c",
  null
  
)

export default component.exports